import { tryRenderImpervaWaitingPage } from './app/modules/landingPages/imperva-waiting-page';

if (tryRenderImpervaWaitingPage()) {
  // Sandboxed Imperva iframe: waiting UI only. Do not boot Angular,
  // Datadog, or the frame-buster (those touch storage / parent / top).
} else {
  void bootstrapSaudiaApp();
}

async function bootstrapSaudiaApp(): Promise<void> {
  const { initFrameBuster } = await import('./app/shared/common/frame-buster');
  initFrameBuster();

  const { datadogRum } = await import('@datadog/browser-rum');
  const { environment } = await import('./environments/environment');

  const rumConfig = environment.datadogRum;

  const isPlaceholder = (value: string) =>
    !value || value.startsWith('<') || value.endsWith('>');

  const canInitializeRum =
    !!rumConfig?.applicationId &&
    !!rumConfig?.clientToken &&
    !!rumConfig?.site &&
    !isPlaceholder(rumConfig.service) &&
    !isPlaceholder(rumConfig.env) &&
    !isPlaceholder(rumConfig.version);

  if (canInitializeRum) {
    datadogRum.init({
      applicationId: rumConfig.applicationId,
      clientToken: rumConfig.clientToken,
      site: rumConfig.site,
      service: rumConfig.service,
      env: rumConfig.env,
      version: rumConfig.version,
      sessionSampleRate: rumConfig.sessionSampleRate,
      sessionReplaySampleRate: rumConfig.sessionReplaySampleRate,
      trackResources: rumConfig.trackResources,
      trackUserInteractions: rumConfig.trackUserInteractions,
      trackLongTasks: rumConfig.trackLongTasks,
      defaultPrivacyLevel: 'mask-user-input',
    });

    datadogRum.startSessionReplayRecording();
  }

  const { platformBrowserDynamic } = await import('@angular/platform-browser-dynamic');
  const { AppModule } = await import('./app/app.module');
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}
